var Actions;
(function (Actions) {
    Actions["GET_ASSETNUMBER_LIST"] = "getAssetNumberList";
    Actions["GET_ASSETNUMBER_LIST_ALLDATA"] = "getAssetNumberListAllData";
    Actions["UPDATE_ASSETNUMBER_SIZE"] = "updateAssetNumberSize";
    Actions["UPDATE_ASSET_NUMBER_PAGE_FILTER"] = "updateAssetNumberPageFilter";
    Actions["UPDATE_ASSET_NUMBER_DESC"] = "updateAssetNumberDesc";
    Actions["UPDATE_SUB_ASSET_NUMBER_DESC"] = "updateSubAssetNumberDesc";
    Actions["UPDATE_ASSET_DESCRIPTION_DESC"] = "updateAssetDescriptionDesc";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    // asset number for module mapping profilling, budget catalog
    Mutations["SET_ASSETNUMBER_LIST"] = "setAssetNumberList";
    Mutations["SET_ASSETNUMBER_HANDLE_PAGE"] = "setAssetNumberHandlePage";
    Mutations["SET_ASSETNUMBER_PAGE"] = "setAssetNumberPage";
    Mutations["SET_ASSETNUMBER_LOAD_PAGE"] = "setAssetNumberLoadPage";
    Mutations["SET_ASSETNUMBER_LOADING"] = "setAssetNumberLoading";
    Mutations["SET_ASSETNUMBER_STATUS"] = "setAssetNumberStatus";
    Mutations["SET_SELECTED_ASSETNUMBER"] = "setSelectedAssetNumber";
    Mutations["SET_DROPDOWNLIST_ASSETNUMBER"] = "setDropdownlistAssetNumber";
    Mutations["SET_DROPDOWNLIST_SUB_ASSETNUMBER"] = "setDropdownlistSubAssetNumber";
    Mutations["SET_DROPDOWNLIST_ASSET_DESCRIPTION"] = "setDropdownlistAssetDescription";
    Mutations["SET_ASSETNUMBER_SIZE"] = "setAssetNumberSize";
    Mutations["SET_ASSETNUMBER_HANDLE_SIZE"] = "setAssetNumberHandleSize";
    Mutations["SET_ASSET_NUMBER_PAGE_FILTER"] = "setAssetNumberPageFilter";
    Mutations["SET_ASSET_NUMBER_WAS_LOAD_QUICK_FILTER"] = "setAssetNumberWasLoadQuickFilter";
    Mutations["SET_ASSET_NUMBER_DESC"] = "setAssetNumberDesc";
    Mutations["SET_ASSET_NUMBER_SEARCH_BY"] = "setAssetNumberSearchBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
